/*=========================================================================================
  File Name: moduleDeviceActions.js
  Description: Device Module Actions
==========================================================================================*/

import api from "../../api/apiService"

export default {

    // device list
    fetchDevices({ commit }) {
    //   return api.device(true, 'list', null, (res) => {
      return api.device(true, 'list', {count: 3000}, (res) => { // 3000 - max in api
        if (res.success && res.msg == 'ok') {
          commit('SET_DEVICES', res.data)
        }
      });
    },

    // device
    fetchDevice({ commit }, payload) {
      // commit('SET_DEVICE', {})
      return api.device(true, 'list', payload, (res) => {
        if (res.success && res.msg == 'ok') {
          commit('SET_DEVICE', res.data[0])
        }
      });
    },

    // device log
    logDevice({ commit }, payload) {
      commit('SET_DEVICE_LOG', [])
      return api.device(true, 'log', payload, (res) => {
        if (res.success && res.msg == 'ok') {
          commit('SET_DEVICE_LOG', res.data)
        // } else if (res.msg == 'empty') {
          // commit('SET_DEVICE_LOG', [])
        }
      });
    },

    // device create
    createDevice({ commit }, payload) {
      return api.device(true, 'create', payload, (res) => {
        if (res.success && res.msg == 'ok') {
          payload.did = res.did;
          commit('CREATE_DEVICE', payload);
          api.emitNotifyEvent({
            title: 'Создание нового устройства',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Создание нового устройства',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // device edit
    updateDevice({ commit }, payload) {
      return api.device(true, 'edit', payload, (res) => {
        if (res.success && (res.msg == 'ok' || res.msg == 'no change')) {
          commit('UPDATE_DEVICE', payload)
          api.emitNotifyEvent({
            title: 'Редактирование устройства',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Редактирование устройства',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // device delete
    deleteDevice({ commit }, payload) {
      return api.device(true, 'delete', { did: payload.did }, (res) => {
        if (res.success && res.msg == 'ok') {
          commit('DELETE_DEVICE', payload)
          api.emitNotifyEvent({
            title: 'Удаление устройства',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Удаление устройства',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // devices delete
    deleteDevices({ commit }, payload) {
      let did_str = '';
      let first = true;
      payload.forEach(value => {
        if (!first) {
          did_str += ','
        }
        first = false
        did_str += value.did
      })
      // api.device(true, 'delete', { did: did_str, debug: 1 }, (res) => {
      return api.device(true, 'delete', { did: did_str }, (res) => {
        if (res.success && res.msg == 'ok') {
          commit('DELETE_DEVICES', payload)
          api.emitNotifyEvent({
            title: 'Удаление устройств',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else if (res.msg == 'constraint') {
          api.emitNotifyEvent({
            title: 'Удаление устройств',
            text: "Чтобы удалить устройства, их необходимо отвязать от партнера и от объекта.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Удаление устройств',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },
    
    // device log delete
    deleteDeviceLog({ commit }, payload) {
      let lid_str = '';
      let first = true;
      payload.forEach(value => {
        if (!first) {
          lid_str += ','
        }
        first = false
        lid_str += value.lid
      })
      return api.device(true, 'deletelog', { lid: lid_str }, (res) => {
        if (res.success && res.msg == 'ok') {
          commit('DELETE_DEVICE_LOG', payload)
          api.emitNotifyEvent({
            title: 'Удаление сообщений устройства',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Удаление сообщений устройства',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },
    
    // devices disconnect
    disconnectDevices({ commit }, payload) {
      let did_str = '';
      let first = true;
      payload.forEach(value => {
        if (!first) {
          did_str += ','
        }
        first = false
        did_str += value.did
      })
      return api.device(true, 'disconnect', { did: did_str }, (res) => {
        if (res.success && (res.msg == 'ok' || res.msg == 'no change')) {
          commit('', payload)
          api.emitNotifyEvent({
            title: 'Отключение устройств',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Отключение устройств',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },
    
    // devices enable
    enableDevices({ commit }, payload) {
      let did_str = '';
      let first = true;
      payload.forEach(value => {
        if (!first) {
          did_str += ','
        }
        first = false
        did_str += value.did
      })
      return api.device(true, 'edit', { did: did_str, enable: 1 }, (res) => {
        if (res.success && (res.msg == 'ok' || res.msg == 'no change')) {
          commit('ENABLE_DEVICES', payload)
          api.emitNotifyEvent({
            title: 'Разрешение для устройств',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Разрешение для устройств',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

    // devices disable
    disableDevices({ commit }, payload) {
      let did_str = '';
      let first = true;
      payload.forEach(value => {
        if (!first) {
          did_str += ','
        }
        first = false
        did_str += value.did
      })
      return api.device(true, 'edit', { did: did_str, enable: 0 }, (res) => {
        if (res.success && (res.msg == 'ok' || res.msg == 'no change')) {
          commit('DISABLE_DEVICES', payload)
          api.emitNotifyEvent({
            title: 'Запрет для устройств',
            text: "Выполнено успешно.",
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success'
          });
        } else {
          api.emitNotifyEvent({
            title: 'Запрет для устройств',
            text: "Ошибка выполнения.",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      });
    },

}
